import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BeneListService } from '../../services/beneList.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalRouteService } from '../../services/modal-route.service';
import { ModalService } from '../../services/modal.service';
import { Utils } from '../../../../Utils';

@Component({
  selector: 'custodian',
  templateUrl: './custodian-component.html',
})
export class CustodianComponent {
  @Input() type;
  custodian;
  custodianForm: FormGroup;
  @Input() dismiss;

  public stateList = Utils.getStateList();
  public widgetType: string;

  constructor(
    private beneListService: BeneListService,
    private modalRouteService: ModalRouteService,
    private router: Router,
    private fb: FormBuilder,
    public modalService: ModalService
  ) {
    this.widgetType = this.beneListService.getChannelName();

    this.custodian = this.beneListService.getCustodian();
    if (this.custodian) {
      this.custodianForm = this.fb.group({
        firstName: [this.custodian.firstName, Validators.required],
        lastName: [this.custodian.lastName],
        state: [this.custodian.state, Validators.required],
      });
    } else {
      this.custodianForm = this.fb.group({
        firstName: ['', Validators.required],
        lastName: [''],
        state: ['', Validators.required],
      });
    }
  }

  saveCustodian(): void {
    const nameInput = this.custodianForm.get('firstName').value;
    const lastNameInput = this.custodianForm.get('lastName').value;
    const stateInput = this.custodianForm.get('state').value;
    const custodian = { firstName: nameInput, lastName: lastNameInput, state: stateInput };
    this.beneListService.setCustodian(custodian);
    this.modalRouteService.changeRoute('bene-list');
  }

  cancel(): void {
    this.modalRouteService.changeRoute('bene-list');
  }

  validate(): boolean {
    if (this.custodian) {
      if (
        this.custodian.firstName === this.custodianForm.get('firstName').value &&
        this.custodian.lastName === this.custodianForm.get('lastName').value &&
        this.custodian.state === this.custodianForm.get('state').value
      ) {
        return true;
      }
    }
    return false;
  }

  checkCancel(): void {
    this.modalService.showModal = true;
  }
}
